import React, { useState } from "react";
import { Calendar, Send, ArrowRight, Phone, Mail, MapPin } from "lucide-react";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    projectType: '',
    budget: '',
    timeline: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    alert('Thank you! We will contact you within 24 hours to schedule your demo.');
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      projectType: '',
      budget: '',
      timeline: '',
      message: ''
    });
  };

  const handleCalendarBooking = () => {
    // Mock calendar booking
    alert('Redirecting to calendar booking system...');
  };

  return (
    <section id="contact" className="py-20" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <div className="hero-announcement mb-6">
            <span style={{ color: '#DC2626' }}>⚠️ LAST CHANCE</span>
            <span>Only 12 Implementation Slots Left This Quarter</span>
          </div>
          <h2 className="heading-1 mb-4">
            Don't Let Competitors <span style={{ color: '#DC2626' }}>Steal Your Market Share</span>
          </h2>
          <p className="body-large" style={{ 
            maxWidth: '600px', 
            margin: '0 auto',
            color: 'var(--text-primary)',
            fontWeight: '500'
          }}>
            Every day you wait, competitors gain ground with AI automation. 
            <strong>Secure your competitive advantage before it's too late.</strong>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Form */}
          <div className="voice-card" style={{ background: 'var(--bg-card)' }}>
            <h3 className="voice-card-title mb-6">
              Project Assessment Form
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="body-small block mb-2">Name *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full p-3 border rounded-lg body-small"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-page)' 
                    }}
                  />
                </div>
                <div>
                  <label className="body-small block mb-2">Email *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full p-3 border rounded-lg body-small"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-page)' 
                    }}
                  />
                </div>
              </div>

              <div>
                <label className="body-small block mb-2">Company</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  className="w-full p-3 border rounded-lg body-small"
                  style={{ 
                    borderColor: 'var(--border-input)',
                    background: 'var(--bg-page)' 
                  }}
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="body-small block mb-2">Project Type</label>
                  <select
                    name="projectType"
                    value={formData.projectType}
                    onChange={handleInputChange}
                    className="w-full p-3 border rounded-lg body-small"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-page)' 
                    }}
                  >
                    <option value="">Select type...</option>
                    <option value="automation">Process Automation</option>
                    <option value="analysis">Data Analysis & Insights</option>
                    <option value="customer">Customer Service AI</option>
                    <option value="sales">Sales & Marketing AI</option>
                    <option value="custom">Custom Solution</option>
                  </select>
                </div>
                <div>
                  <label className="body-small block mb-2">Budget Range</label>
                  <select
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    className="w-full p-3 border rounded-lg body-small"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-page)' 
                    }}
                  >
                    <option value="">Select range...</option>
                    <option value="10k-25k">$10k - $25k</option>
                    <option value="25k-50k">$25k - $50k</option>
                    <option value="50k-100k">$50k - $100k</option>
                    <option value="100k+">$100k+</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="body-small block mb-2">Timeline</label>
                <select
                  name="timeline"
                  value={formData.timeline}
                  onChange={handleInputChange}
                  className="w-full p-3 border rounded-lg body-small"
                  style={{ 
                    borderColor: 'var(--border-input)',
                    background: 'var(--bg-page)' 
                  }}
                >
                  <option value="">Select timeline...</option>
                  <option value="immediate">Immediate (1-2 weeks)</option>
                  <option value="month">Within a month</option>
                  <option value="quarter">This quarter</option>
                  <option value="exploring">Just exploring</option>
                </select>
              </div>

              <div>
                <label className="body-small block mb-2">Project Details</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  placeholder="Tell us about your specific AI needs and challenges..."
                  className="w-full p-3 border rounded-lg body-small resize-none"
                  style={{ 
                    borderColor: 'var(--border-input)',
                    background: 'var(--bg-page)' 
                  }}
                />
              </div>

              <button type="submit" className="btn-primary w-full flex items-center justify-center gap-2 hover-scale">
                <Send size={16} />
                Submit Assessment
              </button>
            </form>
          </div>

          {/* Quick Actions & Info */}
          <div className="space-y-8">
            {/* Calendar Booking */}
            <div className="voice-card accent-blue">
              <div className="flex items-start gap-4 mb-4">
                <Calendar size={32} style={{ color: 'var(--accent-blue-400)' }} />
                <div>
                  <h3 className="voice-card-title">Schedule Demo Call</h3>
                  <p className="voice-card-description">
                    Book a 30-minute consultation to discuss your AI needs and see our system in action.
                  </p>
                </div>
              </div>
              <button 
                onClick={handleCalendarBooking}
                className="btn-primary flex items-center gap-2 hover-scale"
              >
                Book Calendar Slot
                <ArrowRight size={16} />
              </button>
            </div>

            {/* Contact Info */}
            <div className="voice-card" style={{ background: 'var(--bg-card)' }}>
              <h3 className="voice-card-title mb-4">Get in Touch</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Phone size={20} style={{ color: 'var(--accent-orange-400)' }} />
                  <div>
                    <div className="body-small font-medium">Phone</div>
                    <div className="caption">+1 (555) 123-4567</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Mail size={20} style={{ color: 'var(--accent-purple-400)' }} />
                  <div>
                    <div className="body-small font-medium">Email</div>
                    <div className="caption">contact@aithatwows.com</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <MapPin size={20} style={{ color: 'var(--accent-green-200)' }} />
                  <div>
                    <div className="body-small font-medium">Office</div>
                    <div className="caption">San Francisco, CA</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Response Time */}
            <div className="p-6 rounded-lg text-center" style={{ background: 'var(--accent-green-200)' }}>
              <h4 className="heading-3 mb-2">Quick Response</h4>
              <p className="body-small">
                We typically respond within 4 hours during business hours
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;